export enum TipoProcessoDocumentoVisibilidade {
  PUBLICO = 'PUBLICO',
  RESTRITO = 'RESTRITO'
}
